export interface ServiceData {
    id: string;
    title: string;
    subtitle: string;
    description: string;
    shortDesc: string;
    image: string;
    pricing: { name: string; value: string; detail?: string }[];
    features: string[];
}

export const SERVICES_DB: { [key: string]: ServiceData } = {
    
    'day-pass': {
        id: 'Day Pass',
        title: 'Day Pass',
        subtitle: 'Trabaja desde Hot desks, áreas comunes o jardines.',
        description: 'Acceso a la planta compartida (con laptop) por el día de 9 a 18hs.',
        shortDesc: 'Acceso a la planta compartida (con laptop) por el día de 9 a 18hs.',
        image: 'slide1.jpg',
        pricing: [
            { name: 'Pase Diario', value: '$44.000 + iva', detail: 'Por persona, por día' }
        ],
        features: [
            'Internet de Alta Velocidad por fibra óptica + redundancia',
            'Acceso a Phonebooths',
            'Recepción de visitas y de correspondencia',
            'Acceso a las áreas comunes',
            'Área coffee con todo incluido (café, té, yerba, frutas de estación, cookies)'
        ]
    },

    'surf-desk': {
        id: 'Surf Desk',
        title: 'Surf Desk',
        subtitle: '1 o 2 veces por semana, una alternativa entre Day pass y Full Flex.',
        description: 'Acceso a un puesto en planta compartida, por orden de llegada, modalidad laptop.',
        shortDesc: 'Acceso a la planta compartida (con laptop) 1 o 2 dias a la semana.',
        image: 'slide2.jpg',
        pricing: [
            { name: 'Surf 1', value: '$152.000 + iva', detail: 'Por persona' },
            { name: 'Surf 2', value: '$180.000 + iva', detail: 'Por persona' }
        ],
        features: [
            'Acceso 1 o 2 veces por semana, de lunes a viernes de 9hs a 19hs',
            'Internet de Alta Velocidad por fibra óptica + redundancia',
            'Acceso a Phonebooths',
            'Acceso a las áreas comunes',
            'Acceso a los eventos de la comunidad',
            'Área coffee con todo incluido (hot coffee, té, yerba, frutas de estación, cookies)'
        ]
    },

    'full-flex': {
        id: 'Full Flex',
        title: 'Full Flex',
        subtitle: 'El mix perfecto, flexible y en contacto con la comunidad de Usi.',
        description: 'Acceso a un puesto en planta compartida, modalidad laptop.',
        shortDesc: 'Acceso a un puesto fijo en planta compartida para mayor comodidad.',
        image: 'slide3.jpg',
        pricing: [
            { name: 'Mensual', value: '$218.000 + iva', detail: 'Por persona' }
        ],
        features: [
            'Acceso de lunes a viernes de 9hs a 21hs',
            'Internet de Alta Velocidad por fibra óptica + redundancia',
            'Acceso a Phonebooths',
            'Recepción de visitas y de correspondencia',
            'Acceso a las áreas comunes',
            'Acceso a los eventos de la comunidad',
            'Área coffee con todo incluido (hot coffee, té, yerba, frutas de estación, cookies)'
        ]
    },

    'fix': {
        id: 'Fix',
        title: 'Fix',
        subtitle: 'Más espacio para trabajar a tu manera.',
        description: 'Acceso a un puesto fijo en planta compartida, con más espacio para dejar tu set-up.',
        shortDesc: 'Acceso a un puesto fijo en planta compartida para mayor comodidad.',
        image: 'slide4.jpg',
        pricing: [
            { name: 'Mensual', value: '$272.000 + iva', detail: 'Por persona' }
        ],
        features: [
            'Acceso de lunes a viernes de 8:30hs a 21hs (feriados inclusive)',
            'Internet de Alta Velocidad por fibra óptica + redundancia',
            'Locker incluido',
            'Acceso a Phonebooths',
            'Créditos para uso de Salas de Reuniones',
            'Recepción de visitas y de correspondencia',
            'Acceso a los eventos de la comunidad',
            'Acceso a las áreas comunes',
            'Área coffee con todo incluido (hot coffee, té, yerba, frutas de estación, cookies)'
        ]
    },

    'private-office': {
        id: 'Private Office',
        title: 'Private Office',
        subtitle: 'Oficinas privadas y pisos dedicados, con todo lo que necesitas.',
        description: 'Acceso a una oficina privada, de 4 a 70 personas, con contratos flexibles y un layout diseñado para tu equipo.',
        shortDesc: 'Oficinas privadas de 4 a 70 personas con todo lo que necesitás.',
        image: 'privateoffice2.jpeg',
        pricing: [
            { name: 'Desde', value: 'USD 1.200 + iva', detail: 'Equivalente a una oficina de 4 seats' }
        ],
        features: [
            'Acceso 24/7 (con pre-aviso) los 365 días del año',
            'Internet de Alta Velocidad por fibra óptica + redundancia',
            'Créditos para uso de Salas de Reuniones',
            'Acceso a Phonebooths',
            'Recepción de visitas y de correspondencia',
            'Acceso a las áreas comunes',
            'Acceso a los eventos de la comunidad',
            'Servicio de limpieza todos los días',
            'Área coffee con todo incluido (hot coffee, té, yerba, frutas de estación, cookies)'
        ]
    },

    'auditorio': {
        id: 'Auditorio',
        title: 'Auditorio',
        subtitle: 'Espacio dedicado para meet ups, streaming, y eventos de todo tipo.',
        description: 'Espacio exclusivo para que puedas potenciar tus encuentros al máximo.',
        shortDesc: 'Espacio dedicado para meetups, streamings y eventos de todo tipo.',
        image: 'slide6.jpg',
        pricing: [
            { name: 'Evento', value: 'USD 1.100 + iva', detail: 'Equivalente a una jornada completa' }
        ],
        features: [
            '+ 45 posiciones en mesas con ruedas',
            'Formato speaker 100 personas',
            'Versatilidad de layout',
            'Privacidad total',
            'Incluye 2 Salas de reuniones (10 y 6 personas)',
            'Wifi simétrico exclusivo',
            'TV HD 70 pulg.',
            'Proyector y pizarras'
        ]
    },

    'meeting-rooms': {
        id: 'Meeting Rooms',
        title: 'Meeting Rooms',
        subtitle: 'Encontrate con tu equipo en Usina.',
        description: 'Salas de reuniones de 4 a 12 personas, con TV y pizarra, y acceso a los jardines.',
        shortDesc: 'Jornadas en salas de reuniones de 4 a 12 personas.',
        image: 'meetingrooms2.jpeg',
        pricing: [
            { name: 'Jornada', value: '$353.000 + iva', detail: 'Equivalente a 1 jornada completa en sala grande, 13 pax' }
        ],
        features: [
            'Internet de Alta Velocidad por fibra óptica + redundancia',
            'Alquiler de jornada completa, o media jornada',
            'Acceso a las áreas comunes',
            'Área coffee con todo incluido (café, té, yerba, frutas de estación, cookies)'
        ]
    },

    'hq': {
        id: 'HQ',
        title: 'Head Quarter',
        subtitle: 'En esta unidad te ayudamos con tu oficina ideal, llave en mano.',
        description: 'Desarrollamos con un calificado equipo de desarrollo, la oficina ideal para satisfacer las necesidades comerciales de tu empresa.',
        shortDesc: 'Asesoría y gestión para Headquarters llave en mano.',
        image: 'slide8.jpg',
        pricing: [
            { name: 'Cotización', value: 'A medida', detail: 'Consultar por proyectos llave en mano' }
        ],
        features: [
            'Contratos flexibles',
            'Espacios dedicados para una sola empresa',
            'Completamente amobladas',
            'Llave en mano',
            'Management integral'
        ]
    }
};